export { default as Navbar } from './Navbar/Navbar'
export { default as SideHeader } from './SideHeader/SideHeader'
export { default as PageHeader } from './PageHeader/PageHeader'
export { default as PageNotFound } from './PageNotFound/PageNotFound'
export { default as Footer } from './Footer/Footer'
export { default as Loader } from './Loader/Loader'
export { default as PageLoader } from './PageLoader/PageLoader'

export { default as About } from './About/About'
export { default as Facility } from './Facility/Facility'

export { default as Pos } from './Academics/Pos/Pos'
export { default as Courses } from './Academics/Courses/Courses'
export { default as Syllabus } from './Academics/Syllabus/Syllabus'
export { default as Admission } from './Admission/Admission'


export { default as Hod } from './People/Hod/Hod'
export { default as Faculty } from './People/Faculty/Faculty'
export { default as Students } from './People/Students/Students'
export { default as Alumni } from './People/Alumni/Alumni'
export { default as FacultyProfile } from './People/Faculty/FacultyProfile/FacultyProfile'

export { default as Why } from './Placement/Why/Why'
export { default as Internshipstats } from './Placement/Internshipstats/Internshipstats'
export { default as Placementstats } from './Placement/Placementstats/Placementstats'

export { default as Achievements } from './Activities/Achievements/Achievements'
export { default as Projects } from './Activities/Projects/Projects'
export { default as Clubs } from './Activities/Clubs/Clubs'
export { default as ClubProfile } from './Activities/ClubProfile/ClubProfile'
export { default as ClubAllEvents } from './Activities/ClubAllEvents/ClubAllEvents'

export { default as ImageSlider } from './Home/ImageSlider/ImageSlider'
export { default as HomeAbout } from './Home/HomeAbout/HomeAbout'
export { default as HomeHod } from './Home/HomeHod/HomeHod'
export { default as HomeMisc } from './Home/HomeMisc/HomeMisc'
export { default as HomeStats } from './Home/HomeStats/HomeStats'
export { default as Toppers } from './Home/Toppers/Toppers'
export { default as HomePlacement } from './Home/HomePlacement/HomePlacement'
export { default as HomeFacilities } from './Home/HomeFacilities/HomeFacilities'
export { default as Gallery } from './Home/Gallery/Gallery'
export { default as Testimonials } from './Home/Testimonials/Testimonials'

export { default as Contacts } from './Contacts/Contacts'
export { default as Team } from './Team/Team'
export { default as ImageGallery } from './ImageGallery/ImageGallery'
export { default as Announcements } from './Announcements/Announcements'



// -- ADMIN --

export { default as ProtectedRoutes } from './Admin/ProtectedRoutes'
export { default as Dashboard } from './Admin/Dashboard/Dashboard'

export { default as ViewFaculty } from './Admin/Faculty/ViewFaculty'

export { default as FacultyUpdate } from './People/Faculty/FacultyProfileUpdate/FacultyUpdate'
export { default as FacultyLogin } from './People/Faculty/FacultyLogin/FacultyLogin'
export { default as FacultyProtectedRoutes } from './People/Faculty/FacultyProtectedRoutes'
export { default as FacultyChangePassword } from './People/Faculty/FacultyChangePassword'

export { default as ClubLogin } from './Activities/ClubProfile/ClubLogin/ClubLogin'
export { default as ClubProtectedRoutes } from './Activities/ClubProfile/ClubProtectedRoutes'
export { default as ClubUpdate } from './Activities/ClubProfile/ClubUpdate/ClubUpdate'
export { default as ClubChangePassword } from './Activities/ClubProfile/ClubChangePassword/ClubChangePassword'

export { default as EventAdd } from './Activities/Events/EventAdd/EventAdd'
export { default as EventUpdate } from './Activities/Events/EventUpdate/EventUpdate'

export { default as AddFacility } from './Admin/Facilities/AddFacility'
export { default as UpdateFacility } from './Admin/Facilities/UpdateFacility'
export { default as ViewFacility } from './Admin/Facilities/ViewFacility'

export { default as AddAchievements } from './Admin/Achievements/AddAchievements'
export { default as UpdateAchievements } from './Admin/Achievements/UpdateAchievements'
export { default as ViewAchievements } from './Admin/Achievements/ViewAchievements'

export { default as AddAnnouncements } from './Admin/Announcements/AddAnnouncements'
export { default as UpdateAnnouncements } from './Admin/Announcements/UpdateAnnouncements'
export { default as ViewAnnouncements } from './Admin/Announcements/ViewAnnouncements'

export { default as AddSyllabus } from './Admin/Syllabus/AddSyllabus'
export { default as UpdateSyllabus } from './Admin/Syllabus/UpdateSyllabus'
export { default as ViewSyllabus } from './Admin/Syllabus/ViewSyllabus'

export { default as AddToppers } from './Admin/Toppers/AddToppers'
export { default as UpdateToppers } from './Admin/Toppers/UpdateToppers'
export { default as ViewToppers } from './Admin/Toppers/ViewToppers'

export { default as AddTestimonials } from './Admin/Testimonials/AddTestimonials'
export { default as UpdateTestimonials } from './Admin/Testimonials/UpdateTestimonials'
export { default as ViewTestimonials } from './Admin/Testimonials/ViewTestimonials'

export { default as AddPlacementCarousel } from './Admin/PlacementCarousel/AddPlacementCarousel'
export { default as UpdatePlacementCarousel } from './Admin/PlacementCarousel/UpdatePlacementCarousel'
export { default as ViewPlacementCarousel } from './Admin/PlacementCarousel/ViewPlacementCarousel'

export { default as AddLandingCarousel } from './Admin/LandingCarousel/AddLandingCarousel'
export { default as UpdateLandingCarousel } from './Admin/LandingCarousel/UpdateLandingCarousel'
export { default as ViewLandingCarousel } from './Admin/LandingCarousel/ViewLandingCarousel'

export { default as AddGallery } from './Admin/Gallery/AddGallery'
export { default as UpdateGallery } from './Admin/Gallery/UpdateGallery'
export { default as ViewGallery } from './Admin/Gallery/ViewGallery'

export { default as AddProject } from './Admin/Project/AddProject'
export { default as UpdateProject } from './Admin/Project/UpdateProject'
export { default as ViewProject } from './Admin/Project/ViewProject'

export { default as ClubRegister } from './Admin/Auth/ClubRegister/ClubRegister'